// src/pages/Tools/components/ToolFaqCta.tsx
// Replaces: .faq-cta-tool, .faq-link-tool

import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../../lib/utils';
import { ArrowRight } from 'lucide-react';

interface ToolFaqCtaProps {
    /** The prompt text shown above the link */
    prompt?: string;
    /** Link destination path */
    to: string;
    /** Link label */
    label?: string;
    className?: string;
}

/*
 * .faq-cta-tool:
 *   text-align: center; padding-top: 24px; border-top: 1px solid #dadce0;
 *
 * .faq-cta-tool p:
 *   font-size: 0.9375rem; color: #5f6368; margin: 0 0 12px;
 *
 * .faq-link-tool:
 *   display: inline-flex; align-items: center; gap: 6px;
 *   color: #1a73e8; font-size: 0.9375rem; font-weight: 500;
 *   text-decoration: none; transition: gap 0.2s;
 *   :hover → gap: 10px; text-decoration: underline;
 */
const ToolFaqCta: React.FC<ToolFaqCtaProps> = ({
    prompt = 'Have more questions?',
    to,
    label = 'Browse all FAQs',
    className,
}) => (
    <div className={cn(
        'text-center pt-[24px] border-t border-[#dadce0]',
        className,
    )}>
        <p className="text-[0.9375rem] text-[#5f6368] m-0 mb-[12px]">
            {prompt}
        </p>
        <Link
            to={to}
            className={cn(
                'inline-flex items-center gap-[6px]',
                'text-[#1a73e8] text-[0.9375rem] font-medium no-underline',
                'transition-[gap] duration-200',
                'hover:gap-[10px] hover:underline',
            )}
        >
            {label}
            <ArrowRight size={16} />
        </Link>
    </div>
);

export default ToolFaqCta;
